import { defineType } from 'sanity';

export const trust = defineType({
    name: 'trust',
    title: 'Trust section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'image',
            title: 'Image',
            type: 'seoOptimizedImageUrl',
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Trust: ${title['en'] || title['sr']}`,
            };
        },
    },
});
